import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import { LanguageToggleProps } from '../types';

export const LanguageToggle: React.FC<LanguageToggleProps> = ({
  currentLanguage,
  onLanguageChange,
}) => {
  const handleLanguageClick = (language: 'en' | 'no') => {
    if (currentLanguage !== language) {
      onLanguageChange(language);
    }
  };

  return (
    <ButtonGroup size="small" variant="outlined">
      <Button
        variant={currentLanguage === 'no' ? 'contained' : 'outlined'}
        onClick={() => handleLanguageClick('no')}
        data-testid="language-no"
      >
        NO
      </Button>
      <Button
        variant={currentLanguage === 'en' ? 'contained' : 'outlined'}
        onClick={() => handleLanguageClick('en')}
        data-testid="language-en"
      >
        EN
      </Button>
    </ButtonGroup>
  );
};
